import { CreateProjectDocument } from '@/generated/graphql';
import { useMyUser } from '@/user/composables/useMyUser';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { ProjectCreateSchemaType } from '../schemas';

export function useProjectCreate(seriesId: Ref<string>, data: Ref<ProjectCreateSchemaType>) {
    const createProject = useMutation(CreateProjectDocument);
    const { currentUser } = useMyUser();

    async function create() {
        const saveData = { ...toValue(data), status: toValue(data).status?.id ?? null };
        const res = await createProject.mutate({
            seriesId: toValue(seriesId),
            ...saveData,
            createdById: currentUser.value.id,
            createdByName: currentUser.value.name,
        });
        const { id } = res?.data?.createProject?.project ?? {};
        if (id) {
            return { id, errors: [] };
        }
        return { id: undefined, errors: res?.errors };
    }

    return {
        create,
    };
}
